import React from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Icon } from '@/components';
import { RootStore } from '@/models';
import ActionBtn from '../ActionBtn';
import styles from './index.less';
import classNames from 'classnames';

interface Props extends Partial<Pick<RootStore, 'meeting'>> {
  RTCInstance?: RootStore['rtc'];
  meeting?: RootStore['meeting'];
}
const MemberBtn: React.FC<Props> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const { RTCInstance, meeting } = props;
    const { formatMessage } = useIntl();

    return (
      <ActionBtn
        bottomTitle={formatMessage({ id: 'MEMBER_MANAGEMENT' })}
        className={classNames(styles.MemberBtn, {
          [styles.disable]: RTCInstance?.breakLineReconnecting,
        })}
        onClick={() => {
          if (RTCInstance?.breakLineReconnecting) {
            return;
          }
          meeting?.setPeoplePanelShow(true);
        }}
      >
        <Icon className={styles.icon} name="icon-contact" />
      </ActionBtn>
    );
  })
);

export default MemberBtn;
